import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Dropdown } from "@faire/web--source/slate/Dropdown";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackCxFoundationsSelfServiceInitView } from "@faire/web-api--source/events/cxFoundations/view/selfServiceInit";
import React, { useEffect } from "react";

import { DropdownGroups } from "../components/DropdownGroups";
import { NotBrandNorRetailerMessage } from "../components/NotBrandNorRetailerMessage";
import { useLoggedOutIssuesDropdown } from "../hooks/useLoggedOutIssuesDropdown";
import { useLoggedOutUserType } from "../hooks/useLoggedOutUserType";
import {
  CUSTOMER_TYPE_PROMPT_MESSAGE,
  getCustomerTypeList,
} from "../shared-text";

export const LoggedOutSelectTopicView: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const customerListType = getCustomerTypeList(strictLocalize);

  const { user, isKnownUserType, isUnknownUserType } = useLoggedOutUserType();
  const { handleUserDropdown } = useLoggedOutIssuesDropdown();

  useEffect(() => {
    trackCxFoundationsSelfServiceInitView("", "");
  }, []);

  return (
    <Column justify="flex-start" data-test-id="logged-out-select-topic-view">
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg defaultMessage="How can we help you?" />
      </Typography>
      <Spacer height="2x" />
      <Typography>
        <StrictLocalMsg defaultMessage="We need a bit more info to connect you with the right customer support team." />
      </Typography>
      <Spacer height="2x" />
      <Dropdown
        value={user}
        placeholder={CUSTOMER_TYPE_PROMPT_MESSAGE(strictLocalize)}
        options={customerListType}
        onSelect={handleUserDropdown}
        data-test-id="retailer-or-brand-dropdown"
      />
      <Spacer height="2x" />
      {isKnownUserType ? <DropdownGroups /> : null}
      <NotBrandNorRetailerMessage visible={isUnknownUserType} />
    </Column>
  );
};
